import { useLang } from "../i18n";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display text-2xl sm:text-4xl tracking-[0.15em] text-white/85 px-8 whitespace-nowrap">
          {w}
        </span>
        <span className="w-2 h-2 rotate-45 bg-[#D4AF37]/80 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  const words = [
    t("ESPERIENZA", "EXPERIENCE"),
    t("QUALITÀ", "QUALITY"),
    t("AFFIDABILITÀ", "RELIABILITY"),
    "BOLOGNA",
    t("COSTRUIAMO IL TUO FUTURO", "WE BUILD YOUR FUTURE"),
  ];
  return (
    <div
      data-testid="motto-marquee"
      className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0E1726] py-6 select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Row words={words} />
        <Row words={words} />
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#070D18] to-transparent" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#070D18] to-transparent" />
    </div>
  );
};
